
import { Component, Mixins, Prop } from "vue-property-decorator";
import ResearchDataMixin from "@/views/sidebar/research-data/research-data.mixin";
import BaseMixin from "@/views/base/base.mixin";
import moment, { Moment } from "moment";

@Component
export default class RewardsSummary extends Mixins(ResearchDataMixin, BaseMixin) {
  @Prop() rewardsSummaryShow!: boolean;

  loading = false;

  async mounted() {
    this.loading = true;
    const client = await this.waitForClientReady();
    if (client) {
      await this.fetchData();
    } else {
      console.warn("Client not ready in time.");
    }
    this.loading = false;
  }

  async fetchData() {
    const date = moment(this.pickDate).format("YYYY/MM/DD");

    const fetch = [
      this.$store.dispatch("ResearchData/fetchParticipantPaymentSummary", {
        date: date, 
        clientId: this.selectedClientDDL.value,
        participantId: this.researchParticipant.participantId,
        timezone: this.selectedClient.timezone
      })
    ];
    await Promise.all(fetch);
  }

  async moveTime(forward: boolean) {
    this.loading = true;
    this.pickDate = moment(this.pickDate)
      [forward ? "add" : "subtract"](1, "days")
      .toDate();
    await this.fetchData();
    this.loading = false;
  }

  toCurrency(value?: number): string {
    return value === null ? "" : `$${value?.toFixed(2)}`;
  }

  toQuantity(value: number, action: string): string {
    return value === null 
      ? "" 
      : action === "Watch Wear Time"
      ? value < 9
      ? "< 9 Hours"
      : value > 9 && value < 18
      ? "< 18 Hours"
      : "> 18 Hours"
      : `${value}`;
  }

  closeModal() {
    this.$emit('update:rewardsSummaryShow', false);
  }
}
